import React from "react";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";
import "./mainBlog.css"; 
import FromLearnerToMentor from "../../Components/HeroSection/assets/FromLearnertoExpert.png"; 
import IrresistibleProfile from "../../Components/HeroSection/assets/IrresistibleProfile.png"; 
import GetsBooking from "../../Components/HeroSection/assets/GetsBooking.png";
import SuccessStories from "../../Components/HeroSection/assets/SuccessStories.jpg";
import Mistake from "../../Components/HeroSection/assets/Mistake.png"; 
import Help from "../../Components/HeroSection/assets/Help.jpg";
import RealAppointments from "../../Components/HeroSection/assets/RealAppointment.png";
import BookBetter from "../../Components/HeroSection/assets/BookBetter.png";
import Experts from "../../Components/HeroSection/assets/Experts.png";
import Posts from "../../Components/HeroSection/assets/Posts.png";
import Routine from "../../Components/HeroSection/assets/Routine.png"; 
import { Link } from "react-router-dom";

const blogPosts = [
  {
    title: "From Learner to Mentor",
    date: "6/19/2025 2:44 PM",
    image: FromLearnerToMentor,
    link: "/blog/learner-to-mentor",
  
  },
  {
    title: "How to Create an Irresistible Profile on UpskillMeet",
    date: "6/19/2025 2:01 PM",
    image: IrresistibleProfile,
    link: "/blog/irresistible-profile",
  },
  {
    title: "How to Build a Profile That Gets Bookings",
    date: "6/19/2025 5:47 PM",
    image: GetsBooking,
    link: "/blog/profile-that-gets-bookings"
  },
  {
    title: "Student Success Stories",
    date: "6/19/2025 5:47 PM",
    image: SuccessStories,
    link: "/blog/student-success-stories"
  },
  {
    title: "Top Mistakes Experts Make on UpskillMeet",
    date: "6/19/2025 2:28 PM",
    image: Mistake,
    link: "/blog/mistakes-experts-make"
  },
  {
    title: "How to Give and Get Helpful Feedback on UpskillMeet",
    date: "6/19/2025 5:58 PM",
    image: Help,
    link: "/blog/get-helpful-feedback"
  },
  {
    title: "Why You Need to Treat Online Sessions Like Real Appointments",
    date: "6/19/2025 6:07 PM",
    image: RealAppointments,
    link:"/blog/treat-online-sessions"
  },
  {
    title: "Using Queries to Book Better Sessions on UpskillMeet",
    date: "6/19/2025 5:11 PM",
    image: BookBetter,
    link:"/blog/book-better-sessions"
  },
  {
    title: "What to Post on UpskillMeet",
    date: "6/19/2025 3:27 PM",
    image: Posts,
    link:"/blog/what-to-post"
  },
  {
    title: "UpskillMeet: Book Experts, Share Work, and Build Skills",
    date: "6/19/2025 3:27 PM",
    image: Experts,
    link: "/blog/book-experts-share"
  },
  {
    title: "A Day in the Life of an UpskillMeet Expert",
    date: "6/19/2025 5:36 PM",
    image: Routine,
    link: "/blog/day-in-life"
  },
];

const Blog = () => {
  return (
    <div className="card card-one-1 margin refund-policy-wrapper">
      <Navbar />
      <div className="refund-static-content">
        <div className="static-header">
          <h1 className="container">Our Blog</h1>
        </div>

        <div className="container mt-4 blog-grid">
          {blogPosts.map((post, index) => (
            post.link ? (
              <Link to={post.link} key={index} className="blog-card-link">
                <div className="blog-card">
                  <img src={post.image} alt={post.title} className="blog-image" />
                  <div className="blog-content">
                    <h3 className="blog-title">{post.title}</h3>
                    <p className="blog-date">{post.date}</p>
                  </div>
                </div>
              </Link>
            ) : (
              <div key={index} className="blog-card">
                <img src={post.image} alt={post.title} className="blog-image" />
                <div className="blog-content">
                  <h3 className="blog-title">{post.title}</h3>
                  <p className="blog-date">{post.date}</p>
                </div>
              </div>
            )
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Blog;
